export const TooltipText = {
    mainText: "Coming soon: warehouses and quotes dashboards!",
};
